import { useState } from "react";
import { Switch, SwitchGroup } from "@headlessui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChessRook, faChessKnight } from "@fortawesome/free-solid-svg-icons";
import { SelectedRoleProps } from "@/views/home/deadline_guardian/types/types";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export function RoleToggle({ selectedRole }: { selectedRole: SelectedRoleProps }) {
  const [isClaimant, setIsClaimant] = useState(selectedRole === "Claimant");

  return (
    <SwitchGroup as="div" className="mb-4 mt-4 flex items-center">
      <Switch
        checked={isClaimant}
        onChange={setIsClaimant}
        className={classNames(
          isClaimant ? "bg-red-100" : "bg-blue-100",
          "relative inline-flex h-10 w-48 flex-shrink-0 cursor-pointer items-center rounded-full border-2 border-white transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-offset-2",
          isClaimant ? "focus:ring-red-200" : "focus:ring-blue-200",
        )}
      >
        <span
          aria-hidden="true"
          className={classNames(
            "pointer-events-none inline-block h-10 w-10 transform rounded-full pt-2 shadow ring-0 transition-transform duration-200 ease-in-out",
            isClaimant ? "bg-red-700" : "translate-x-0 bg-blue-700",
          )}
          style={{
            transform: isClaimant ? "translateX(9.2rem)" : "translateX(0)", // Adjust as needed, 9.5rem is just an example
          }}
        >
          <FontAwesomeIcon icon={isClaimant ? faChessRook : faChessKnight} className="text-lg text-white" />
        </span>
        <span
          className="absolute ml-1 text-sm font-medium text-gray-900 transition-all duration-200 ease-in-out"
          style={{
            left: isClaimant ? "20px" : "calc(100% - 40px)", // Change here: Calculate position from right
            transform: isClaimant ? "translateX(0)" : "translateX(-100%)",
          }}
        >
          {isClaimant ? "Claimant" : "Defendant"}
        </span>
      </Switch>
    </SwitchGroup>
  );
}
